exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods[data-v-a03fa812]{min-height:50px}", ""]);

// exports
